import { render, staticRenderFns } from "./TextAreaWidget.vue?vue&type=template&id=3eef6060&scoped=true"
import script from "./TextAreaWidget.vue?vue&type=script&lang=js"
export * from "./TextAreaWidget.vue?vue&type=script&lang=js"
import style0 from "./TextAreaWidget.vue?vue&type=style&index=0&id=3eef6060&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eef6060",
  null
  
)

export default component.exports